
export default {
    props: {
        statuses: {
            type: Object,
            default: {}
        }
    },
}
